import type { Phrases } from '../../common/Phrases.d';

// import { today, getLocalTimeZone } from '@internationalized/date';
import React from 'react';
import { DatePicker } from '/react4xp/components/react-hook-form/DatePicker';
import {
	SERVICES_FIELD_NAME,
	WHEN_LEGEND_ID,
} from '../constants';

export const WhenDatePicker = ({
	phrases,
}: {
	phrases: Phrases;
}): React.JSX.Element => {
	return (
		<DatePicker
			aria-labelledby={WHEN_LEGEND_ID}
			hideLabel

			// hideLabel also hides infoText icon
			// infoText={phrases['notificationForm.services.whenField.infoText']}

			label={phrases['notificationForm.services.whenField.label']}
			name={SERVICES_FIELD_NAME.WHEN_DID_THE_INCIDENT_HAPPEN}

			// WARNING: This sorta works, but UI bad, thus used form validation instead.
			// // @ts-expect-error Not added to FRISK typings yet.
			// maxValue={today(getLocalTimeZone())}
		/>
	);
};
